'use client'

import { useInView, useReducedMotion } from 'motion/react'
import React, { useEffect, useRef, useState } from 'react'

import { formatarContador, parseValorContador } from './formatarContador'

type Props = {
  valor: unknown
  prefixo?: string | null
  sufixo?: string | null
  duracaoMs?: number
  className?: string
}

/** Número que sobe de 0 até ao valor quando entra na viewport (uma vez). */
export function Contador({ valor, prefixo, sufixo, duracaoMs = 1600, className }: Props) {
  const { numero, casas } = parseValorContador(valor)
  const ref = useRef<HTMLSpanElement>(null)
  const inView = useInView(ref, { once: true, margin: '0px 0px -10% 0px' })
  const reduce = useReducedMotion()
  const [atual, setAtual] = useState(reduce ? numero : 0)

  useEffect(() => {
    if (!inView || reduce) return
    let raf = 0
    const inicio = performance.now()
    const tick = (t: number) => {
      const p = Math.min(1, (t - inicio) / duracaoMs)
      const eased = 1 - Math.pow(1 - p, 3)
      setAtual(numero * eased)
      if (p < 1) raf = requestAnimationFrame(tick)
    }
    raf = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(raf)
  }, [inView, numero, duracaoMs, reduce])

  const final = formatarContador(numero, casas, prefixo, sufixo)
  return (
    <span ref={ref} className={className} aria-label={final}>
      <span aria-hidden>{formatarContador(reduce ? numero : atual, casas, prefixo, sufixo)}</span>
    </span>
  )
}
